export default "__VITE_ASSET__M5s7h_VI__"